import SendResetLink from './send-link-container';

export default SendResetLink;
